import React, { useState, useRef } from "react";
import { Typography, Button, IconButton } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import Icon from '@material-ui/core/Icon';
import { useHistory } from "react-router-dom";
import RecursiveHorizontalMenu from "./RecursiveHorizontalMenu";
import { genfunction } from "helpers";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        '& > *': {
            //  margin: theme.spacing(0.3)
        },
        // float: 'left',
        marginLeft: '20px',
        color: 'white',
        marginTop: '5px',
    },
    flexGrow: {
        flexGrow: 1,
    },

    linkItem: {
        color: theme.palette.primary.contrastText,
        fontSize: '14px',
        marginTop: '5px',
        cursor: 'pointer',

    },

    menuIcons: {
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.25)',
            boxShadow: '0 0 8px 2px rgba(255, 255, 255, 0.7)',
            color: '#fff',
        },
    },

    dropDownIconButton: {
        padding: '0px !important'
    },

    dropDownIcon: {
        color: theme.palette.primary.contrastText,

    }
}
));


export default function DynamicMenu() {

    const menuAndPages = useSelector(state => state.reducerMenuAndPages.menuAndPages);
    const classes = useStyles();
    const leftMenus = menuAndPages.filter(m => m.Position === 'left');
    const rightMenus = menuAndPages.filter(m => m.Position === 'right');
    const [hoveredAnchor, setHoveredAnchor] = useState(null);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const hoverTimeoutRef = useRef(null);

    let history = useHistory();

    const handleMouseEnter = (e, index) => {

        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
        setHoveredAnchor(e.currentTarget);
        setHoveredIndex(index);
    };

    const handleMouseLeave = () => {

        hoverTimeoutRef.current = setTimeout(() => {
            setHoveredAnchor(null);
            setHoveredIndex(null);
        }, 250);
    };

    const handlePageClick = (pageURL) => {
        if (genfunction.IsExternalUrl(pageURL))
            window.location.href = pageURL;
        else
            history.push(pageURL);
    }

    return (
        <>
            <div className={classes.root}>
                <>
                    {leftMenus?.map((item, index) => {

                        return (
                            <div
                                key={index} onMouseEnter={(e) => handleMouseEnter(e, index)} onMouseLeave={handleMouseLeave}

                            >

                                <Button className={classes.menuIcons} onClick={() => handlePageClick(item?.PageURL)}>

                                    <Icon>{item?.Icon}</Icon>
                                    <Typography className={classes.linkItem}> {genfunction.replaceEscapeCharacters(item?.Title)}</Typography>

                                    {genfunction.IsArrayNotEmptyNullUndefined(item?.MenuAndPages) &&

                                        <IconButton className={classes.dropDownIconButton}>
                                            <Icon fontSize="medium" className={classes.dropDownIcon}>arrow_drop_down</Icon>
                                        </IconButton>


                                    }

                                </Button>

                                {genfunction.IsArrayNotEmptyNullUndefined(item?.MenuAndPages) &&
                                    hoveredIndex === index &&

                                    <RecursiveHorizontalMenu
                                        menu={item}
                                        anchorEl={hoveredAnchor}
                                        onClose={handleMouseLeave}
                                        level={1}
                                        handlePageClick={handlePageClick}
                                    />

                                }

                            </div>
                        )
                    })}


                </>
            </div>
            <div className={classes.flexGrow} />
            <div >
                {
                    rightMenus.map((item) => {
                        return (<Button variant="outlined" size="small" className="ManageMyBooking" onClick={() => history.push(item?.PageURL)}>
                            {genfunction.replaceEscapeCharacters(item?.Title)}
                        </Button>)
                    })

                }
            </div>
        </>
    );
}

